export default __webpack_public_path__ + "static/media/Blue geode3.81bc29cf.jpg";